module.exports = __webpack_public_path__ + "teqbahn-assets/media/blog2.a8874bb4.png";